import classNames from 'classnames';
import { t } from 'ttag';

import { ProductUserStatus, ProductVisibleStatus } from '@models';

import s from './ProductStatusLabel.sss';

type ProductStatuses = Record<string, { label(): string; className: string }>;

const productsStatuses: ProductStatuses = {
  [ProductUserStatus.Hidden]: {
    label: () => t`Деактивований`,
    className: s.hidden,
  },
  [ProductVisibleStatus.Available]: {
    label: () => t`В наявності`,
    className: s.available,
  },
  [ProductVisibleStatus.Reserved]: {
    label: () => t`Резерв`,
    className: s.reserved,
  },
  [ProductVisibleStatus.Sold]: {
    label: () => t`Проданий`,
    className: s.sold,
  },
  [ProductVisibleStatus.ModerationRequired]: {
    label: () => t`На модерації`,
    className: s.moderationRequired,
  },
  [ProductVisibleStatus.Declined]: {
    label: () => t`Відхилене`,
    className: s.declined,
  },
  [ProductVisibleStatus.Deleted]: {
    label: () => t`Видалений`,
    className: s.deleted,
  },
};

interface Props {
  status: keyof ProductStatuses,
  count?: number
}

export const ProductStatusLabel: React.FC<Props> = ({
  status,
  count,
}) => (
  <p className={classNames(s.root, productsStatuses[status]?.className)}>
    {productsStatuses[status]?.label()}

    {!!count && (
      <span className={s.count}>
        {t`${count} шт`}
      </span>
    )}
  </p>
);
